import { render, staticRenderFns } from "./workflow-settings-manager.vue?vue&type=template&id=4b8b1906"
import script from "./workflow-settings-manager.vue?vue&type=script&lang=js"
export * from "./workflow-settings-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports